import { database } from './config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Empresa {
    constructor() {
        this.Correo = ''
        this.Whatsapp = ''
        this.Facebook = ''
        this.Instagram = ''
        this.Linkedin = ''
        this.Twitter = ''
        this.Telefono = ''
    }

    getInfoEmpresa(){ 
        return database.collection('infoEmpresa')
            .doc('info')
            .get()
            .then(doc => doc.data())
    }

    guardarInfoEmpresa(data) {
        return database.collection('infoEmpresa').doc('info').set({
            ...data,
        })
            .then()
            .catch(error => console.error(Error.guardarError(error)))
    }

}